const toTrimmedValue = (value) =>
  typeof value === "string" ? value.trim() : "";

export const normalizeBlockDocId = (blockId) =>
  String(blockId ?? "").trim().toLowerCase();

export const shouldUsePendingBlockPath = (client) => {
  const pendingUserId = toTrimmedValue(client?.pendingUserId);
  const coachId = toTrimmedValue(client?.coach?.id);

  if (!pendingUserId || !coachId) return false;
  if (client?.status === "active-string") return false;
  if (client?.usePendingBlocksPath === false) return false;
  if (client?.usePendingBlocksPath === true) return true;

  return toTrimmedValue(client?.invitationId) !== "";
};

export const resolveClientBlocksCollectionPath = (client) => {
  if (shouldUsePendingBlockPath(client)) {
    return [
      "coaches",
      toTrimmedValue(client?.coach?.id),
      "pending_users",
      toTrimmedValue(client?.pendingUserId),
      "blocks",
    ];
  }

  const userId = toTrimmedValue(client?.id);
  if (!userId) return null;

  return ["users", userId, "blocks"];
};

export const resolveClientBlockDocPath = (client, blockId) => {
  const blockDocId = normalizeBlockDocId(blockId);
  if (!blockDocId) return null;

  const collectionPathSegments = resolveClientBlocksCollectionPath(client);
  if (!collectionPathSegments) return null;

  return {
    blockDocId,
    collectionPathSegments,
    pathSegments: [...collectionPathSegments, blockDocId],
  };
};

export const resolvePendingWorkspaceDocPath = (client) => {
  if (!shouldUsePendingBlockPath(client)) return null;

  return [
    "coaches",
    toTrimmedValue(client?.coach?.id),
    "pending_users",
    toTrimmedValue(client?.pendingUserId),
  ];
};
